import type { TextFieldProps } from "$components/inputs";
import { TextField } from "$components/rhf-fields";
import React from "react";
import { useIntl } from "react-intl";

type Props = Omit<TextFieldProps, "clearButtonTitle"> & {
  analyticsName?: string;
  name: string;
};

const TextFieldWrapper: React.FunctionComponent<Props> = ({
  analyticsName,
  ...props
}) => {
  const { formatMessage } = useIntl();

  return (
    <TextField
      {...props}
      clearButtonTitle={formatMessage({
        id: "textField.clear",
        defaultMessage: "Clear",
      })}
    />
  );
};

export default TextFieldWrapper;
